import React from 'react';
import { Spinner } from "../../../Spinner";
import { styles } from './styles';
export function GridLoadingOverlay() {
    return (React.createElement("div", { className: styles.loadingOverlay },
        React.createElement(Spinner, { size: 50 })));
}
//# sourceMappingURL=GridLoadingOverlay.js.map